module.exports = __webpack_public_path__ + "img/teacher03.204f4676.jpeg";